const About = () => {
  return (
    <>
      <div
        name="about"
        className="w-full h-full bg-gradient-to-b from-gray-800 to-black text-white py-20"
      >
        <div className="max-w-screen-lg p-4 mx-auto flex flex-col justify-center w-full h-full">
          <div className="pb-8">
            <p className="text-4xl font-bold inline border-b-4 border-gray-500">
              About
            </p>
          </div>
          <div className="grid md:grid-cols-2 gap-8">
            <div>
              <h2 className="font-bold text-2xl">About Me</h2>
              <p className="text-gray-500 max-w-md py-4 mt-5">
                Hello, I am a passionate MERN Stack Developer and mobile app
                developer based in Nairobi, Kenya. I have always been fascinated
                by technology and the endless possibilities it offers. My
                journey into the world of coding began with a curiosity to
                understand how things work behind the scenes in the digital
                realm.
              </p>
            </div>
            <div>
              <h2 className="font-bold text-2xl ml-4">Journey into Coding</h2>
              <p className="text-gray-500 max-w-md py-4 ml-5">
                My journey into coding started during my Admission to pursue
                Software Development in KCA University. What began as a hobby
                quickly turned into a passion as I delved deeper into the
                intricacies of programming languages and software development. I
                found joy in solving problems and bringing ideas to life through
                code.
              </p>
              <br />
            </div>
            <div>
              <h2 className="font-bold text-2xl">Passion for Programming</h2>
              <p className="text-gray-500 max-w-md py-4 ml-5">
                Programming, for me, is more than just writing lines of code; it
                is about creativity, problem-solving, and continuous learning. I
                am deeply passionate about leveraging technology to create
                meaningful solutions that make a positive impact on peoples
                lives.
              </p>
              <br />
            </div>
            <div>
              <h2 className="font-bold text-2xl">
                MERN Stack and Mobile Development
              </h2>
              <p className="text-gray-500 max-w-md py-4 mt-5">
                Over the years, I have honed my skills in the MERN (MongoDB,
                Express.js, React.js, Node.js) stack, a powerful combination of
                technologies for building modern web applications. Additionally,
                I have ventured into mobile app development, using frameworks
                like Flutter to create cross-platform mobile applications that
                offer a seamless user experience across different devices.
              </p>
              <br />
            </div>
            <div>
              <h2 className="font-bold text-2xl">What Drives Me</h2>
              <p className="text-gray-500 max-w-md py-4 mt-5">
                What drives me in my journey as a developer is the constant
                pursuit of excellence and the desire to push the boundaries of
                what is possible. I thrive in dynamic environments where I can
                collaborate with like-minded individuals and contribute to
                projects that challenge me to grow professionally and
                personally.
              </p>
              <br />
            </div>
          </div>
        </div>
      </div>
      <div className="bg-gradient-to-b from-gray-800 to-black mb-10  w-full h-full"></div>
    </>
  );
};

export default About;
